import * as yup from "yup";
export const changePasswordSchema = yup.object().shape({
  current_password:yup.string().trim().required("Please enter current password"),
  new_password: yup
    .string()
    .required("Please enter new password")
    .test(
      "no-leading-trailing-space",
      "New password should not start or end with a space",
      (value) => !/^\s|\s$/.test(value)
    )
    .min(8, "Current password must be at least 8 characters")
    .matches(
      /^(?=.*[A-Z])(?=.*\d).+$/,
      "Current password must contain at least one uppercase letter and one numeric value"
    ),
    confirm_password: yup
    .string().trim()
    .required("Please repeat password")
    .test(
      "no-leading-trailing-space",
      "Confirm password should not start or end with a space",
      (value) => !/^\s|\s$/.test(value)
    )
    // .min(8, "Password must be at least 8 characters")
    .oneOf([yup.ref("new_password")], "New password and confirm password does not match")
});
